export default __webpack_public_path__ + "static/media/bump-coin.c5fc4848.svg";